import { Chip, ListItem, Modal, ModalBody, Text } from '@change/ds-core-ui';
import { DoneIcon, ExpandIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

type TrackingContext = 'status_filter_trending' | 'status_filter_all' | 'status_filter_victories';

type StatusFilterProps = {
	setAllPetitions: () => void;
	setVictoriesOnly: () => void;
	setTrending: () => void;
	isAllPetitionsChecked: boolean;
	isVictoriesOnlyChecked: boolean;
	isTrendingChecked: boolean;
	disabled: boolean;
	trackStatusFilterClick: (context: TrackingContext) => void;
};

export const MobileStatusFilter: React.FC<StatusFilterProps> = ({
	setAllPetitions,
	setVictoriesOnly,
	setTrending,
	isAllPetitionsChecked,
	isVictoriesOnlyChecked,
	isTrendingChecked,
	disabled,
	trackStatusFilterClick,
}) => {
	return (
		<div className="relative">
			<Modal
				trigger={
					<Chip
						as="button"
						trailingIcon={<ExpandIcon />}
						forceInteractive
						disabled={disabled}
						data-testid="status-filter-chip"
						data-qa="status-filter-chip"
						active={isVictoriesOnlyChecked || isTrendingChecked}
					>
						{isVictoriesOnlyChecked && <Translate value="corgi.search.filters.status.options.victories_only" />}
						{isTrendingChecked && <Translate value="corgi.search.filters.status.options.trending" />}
						{isAllPetitionsChecked && <Translate value="corgi.search.filters.status.options.all" />}
					</Chip>
				}
				onClose={() => {}}
			>
				<ModalBody className="space-y-3 pb-10">
					{({ close }) => (
						<>
							<ListItem
								onClick={() => {
									setAllPetitions();
									trackStatusFilterClick('status_filter_all');
									close();
								}}
								label={
									<Text>
										<Translate value="corgi.search.filters.status.options.all" />
									</Text>
								}
								trailingIcon={isAllPetitionsChecked ? <DoneIcon /> : undefined}
								disabled={disabled}
								className="focus-visible:outline-stroke-focus-outer w-full cursor-pointer focus-visible:outline focus-visible:outline-offset-2"
								data-testid="list-item-all-petitions"
								data-qa="list-item-all-petitions"
							/>
							<ListItem
								onClick={() => {
									setVictoriesOnly();
									trackStatusFilterClick('status_filter_victories');
									close();
								}}
								label={
									<Text>
										<Translate value="corgi.search.filters.status.options.victories_only" />
									</Text>
								}
								trailingIcon={isVictoriesOnlyChecked ? <DoneIcon /> : undefined}
								disabled={disabled}
								className="focus-visible:outline-stroke-focus-outer w-full cursor-pointer focus-visible:outline focus-visible:outline-offset-2"
								data-testid="list-item-victories-only"
								data-qa="list-item-victories-only"
							/>
							<ListItem
								onClick={() => {
									setTrending();
									trackStatusFilterClick('status_filter_trending');
									close();
								}}
								label={
									<Text>
										<Translate value="corgi.search.filters.status.options.trending" />
									</Text>
								}
								trailingIcon={isTrendingChecked ? <DoneIcon /> : undefined}
								disabled={disabled}
								className="focus-visible:outline-stroke-focus-outer w-full cursor-pointer focus-visible:outline focus-visible:outline-offset-2"
								data-testid="list-item-trending"
								data-qa="list-item-trending"
							/>
						</>
					)}
				</ModalBody>
			</Modal>
		</div>
	);
};
